// START_MODULE pages_main_sections_announcements_components_annoucementitem_announcementitem_tsx
// START_CONTRACT
// PURPOSE: Preserve this module from the original Tomsk Data Science frontend.
// OPERATIONAL_CONTEXT: Imported by the public static React application.
// CONTRACT: Keep the established layout, styling, and component behavior intact.
// KEYWORDS: legacy-frontend, static-site, tomsk-data-science
// COMPLEXITY: 2
// END_CONTRACT
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { mainRepository } from 'domain/repositories/MainRepository';
import { IAnnouncement } from 'domain/entities/IAnnouncement';

import { getDate } from 'utils/date/getDate';

interface AnnouncementItemProps {
  announcement: IAnnouncement;
}

const AnnouncementItem: React.FC<AnnouncementItemProps> = ({ announcement }) => {
  const [imageSrc, setImageSrc] = useState<string>('');

  useEffect(() => {
    mainRepository.getImageFile(announcement.imageHeaderId)
      .then((blob) => URL.createObjectURL(blob))
      .then((src) => setImageSrc(src));
  }, [announcement.imageHeaderId]);

  return (
    <AnnouncementWrapper>
      <AnnouncementImage src={imageSrc} />
      <AnnouncementText>
        <h5>{announcement.header}</h5>
        <p className="formatted-text" dangerouslySetInnerHTML={{ __html: announcement.content }} />
        <AnnouncementSubtext>{getDate(announcement.dateAdded)}</AnnouncementSubtext>
      </AnnouncementText>
    </AnnouncementWrapper>
  );
};

const AnnouncementWrapper = styled.div`
  display: flex;
  gap: 16px;

  margin-bottom: 12px;
`;

const AnnouncementImage = styled.img`
  width: 100px;
  height: 100px;
  object-fit: cover;

  image-rendering: auto;
`;

const AnnouncementText = styled.div`
  h5 {
    font-size: 1.1rem;
    margin-bottom: 6px;
  }
  p {
    margin-bottom: 4px;
  }
`;

export const AnnouncementSubtext = styled.p`
  font-size: 0.9rem;
  color: #a7a7a7;
`;

export default AnnouncementItem;

// END_MODULE pages_main_sections_announcements_components_annoucementitem_announcementitem_tsx
